import buildUrl from 'build-url';

// const buildUrl = require('build-url');

// declare function buildUrl(url: string, options: any): string;

let getParam = function (sParam: string): undefined | string {
        let sPageURL = decodeURIComponent(window.location.search.substring(1)),
            sURLVariables = sPageURL.split('&'),
            sParameterName,
            i;

        for (i = 0; i < sURLVariables.length; i++) {
            sParameterName = sURLVariables[i].split('=');

            if (sParameterName[0] === sParam) {
                return sParameterName[1] === undefined ? undefined : sParameterName[1];
            }
        }
        return undefined;
    },
    getParams = function () {
        let sPageURL = decodeURIComponent(window.location.search.substring(1)),
            sURLVariables = sPageURL.split('&'),
            sParameterName,
            i,
            params: any = {};

        for (i = 0; i < sURLVariables.length; i++) {
            sParameterName = sURLVariables[i].split('=');
            if (sParameterName[0] !== undefined && sParameterName[1] !== undefined) {
                params[sParameterName[0]] = sParameterName[1];
            }
        }

        return params;
    },
    setParams = function (setParams: string[]) {
        let params = getParams(),
            sParams = '',
            buildedUrl = '';

        for (let sParam in setParams) {
            if (setParams.hasOwnProperty(sParam)) {
                params[sParam] = setParams[sParam];
            }
        }

        buildedUrl = buildUrl(window.location.protocol + '//' + window.location.host, {
            path: window.location.pathname,
            hash: window.location.hash,
            queryParams: params
        });

        if (buildedUrl !== '') {
            window.location.href = buildedUrl;
        }
    },
    setHash = function (hash: string) {
        window.location.hash = hash;
    },
    removeHash = function () {
        history.pushState("", document.title, window.location.pathname + window.location.search);
    };

const url = {getParam, getParams, setParams, setHash, removeHash};

export {getParam};
export {getParams};
export {setParams};
export {setHash};
export {removeHash};

export default url;
